// extracted by mini-css-extract-plugin
module.exports = {"related":"related-jargon_related__gr6qU","link":"related-jargon_link__rtrun","button":"related-jargon_button__i0Grp"};